import { createProperties, type Field, type TypeToFields } from '@jmvdevelop/svelte-form';
import * as z from 'zod';
import {
    zEducationLevelEnum,
    zExperienceLevelEnum,
    zJobContractTypeEnum,
    zJobRemoteEnum,
    zJobWorkTimeEnum,
    zSearchHeaderFormData_JobContentEnum,
    zSearchHeaderFormData_JobPublicationDateEnum,
} from '$gql/zod-generated';

export const zJobFiltersData = z.object({
    contractTypes: z.array(zJobContractTypeEnum),
    experiences: z.array(zExperienceLevelEnum),
    publicationDate: zSearchHeaderFormData_JobPublicationDateEnum,
    category: z.number().nullable(),
    workTime: zJobWorkTimeEnum.nullable(),
    salary: z.object({ min: z.number(), max: z.number() }),
    jobTitle: z.number().nullable(),
    educationLevels: z.array(zEducationLevelEnum),
    contents: z.array(zSearchHeaderFormData_JobContentEnum),
    company: z.number().nullable(),
    remote: zJobRemoteEnum.nullable(),
});

export type JobFiltersData = z.infer<typeof zJobFiltersData>;
type FormData = JobFiltersData;

export type Fields<TFormValues> = TypeToFields<TFormValues, FormData>;

export const empty: FormData = {
    contractTypes: [],
    educationLevels: [],
    category: null,
    contents: [],
    experiences: [],
    company: null,
    remote: null,
    workTime: null,
    publicationDate: 'all_dates',
    jobTitle: null,
    salary: { min: 0, max: 10_000_000 },
};

export function createFields<TValues>(self: Field<TValues, FormData>): Fields<TValues> {
    return {
        self: self,
        ...createProperties(self, [
            'contractTypes',
            'educationLevels',
            'contents',
            'category',
            'experiences',
            'company',
            'remote',
            'publicationDate',
            'workTime',
            'jobTitle',
            'salary',
        ] as const),
    };
}
